export default __webpack_public_path__ + "static/media/luke.a182bc26.png";